/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import '@angular/localize/init';
import * as monaco from 'monaco-editor';


platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));



// (self as any).MonacoEnvironment = {
// 	getWorkerUrl: function (moduleId: any, label: string) {
// 		return `/assets/monaco/vs/base/worker/workerMain.js`;
// 	}
// };
